import {
	UPDATE_PHARMACY_USER_PROFILE_COVER_REQUEST,
	UPDATE_PHARMACY_USER_PROFILE_COVER_SUCCESS,
	UPDATE_PHARMACY_USER_PROFILE_COVER_FAILURE
} from '../../constants';

const initialState = {
	coverImageUrl: null,
	loading: false,
	error: null
};

const pharmacyUserProfileCoverReducer = (state = initialState, action) => {
	switch (action.type) {
		case UPDATE_PHARMACY_USER_PROFILE_COVER_REQUEST:
			return {
				...state,
				loading: true,
				error: null
			};
		case UPDATE_PHARMACY_USER_PROFILE_COVER_SUCCESS:
			return {
				...state,
				loading: false,
				coverImageUrl: action.payload,
				error: null
			};
		case UPDATE_PHARMACY_USER_PROFILE_COVER_FAILURE:
			return {
				...state,
				loading: false,
				error: action.payload
			};
		default:
			return state;
	}
}

export default pharmacyUserProfileCoverReducer;
